export const HighlightTestIds = {
  removedTextStyling: 'removed_text_styling',
  originalContent: 'original_content',
  originalText: 'original_text',
  originalAuthor: 'original_author',
  changedContent: 'changed_content',
  changedText: 'changed_text',
  changedAuthor: 'changed_author'
} as const;
